var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancelled = function SvgCancelled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reports-Copy-5",
    fill: "currentColor",
    transform: "translate(-342.000000, -1593.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "ic-canceled",
    d: "M353.16275,1603.50337 L355.502101,1601.16652 L354.339283,1600.00495 L351.999932,1602.3418 L349.660581,1600.00495 L348.497763,1601.16652 L350.837114,1603.50337 L348.497763,1605.84022 L349.660581,1607.0018 L351.999932,1604.66495 L354.339283,1607.0018 L355.502101,1605.84022 L353.16275,1603.50337 Z M354.659374,1594.49603 L361.595566,1606.49898 C362.424557,1607.93353 361.933652,1609.7685 360.4991,1610.59749 C360.0428,1610.86117 359.525089,1611 358.99808,1611 L345.001453,1611 C343.344598,1611 342.001453,1609.65685 342.001453,1608 C342.001453,1607.46513 342.144452,1606.93998 342.415638,1606.47896 L349.476073,1594.47601 C350.31612,1593.04791 352.154822,1592.57119 353.582928,1593.41124 C354.029372,1593.67385 354.40022,1594.04757 354.659374,1594.49603 Z"
  })))));
};
export default SvgCancelled;